import React, { useState, useCallback } from 'react'
import Button from '@components/common/Button/Button.component'
import Calendar from '@components/common/CustomCalendar/Calendar.component'
import moment from 'moment'

const CalendarToggle = React.memo(
  ({
    activeTab,
    date,
    startDate,
    endDate,
    onDateChange,
  }: {
    date: string
    activeTab: string
    startDate: string
    endDate: string
    onDateChange: (dateString: string) => void
  }) => {
    const [isCalendarOpen, setIsCalendarOpen] = useState<boolean>(false)

    const toggleCalendar = useCallback(() => {
      setIsCalendarOpen((prev) => !prev)
    }, [])

    const onDateSelect = (e: { value: Date }): void => {
      onDateChange(moment(e.value).format('MMMM D, YYYY'))
      toggleCalendar() //Closed the calendar after selecting date
    }

    const dateDisplay = (): string => {
      if (activeTab === 'day') {
        return moment(date).format('MMM D, YYYY')
      } else if (activeTab === 'week') {
        const start = moment(startDate).format('MMM D, YYYY')
        const end = moment(endDate).format('MMM D, YYYY')
        return `${start} - ${end}`
      } else if (activeTab === 'month') {
        return moment(date).format('MMMM YYYY')
      }

      return ''
    }
    return (
      <div>
        <Button
          className="button-date button-secondary calendar-toggle-button"
          leftIcon={<i className="button-date mgc_calendar_2_fill"></i>}
          rightIcon={<i className="button-date mgc_down_small_fill"></i>}
          onClick={toggleCalendar}
          size={'md'}
        >
          {dateDisplay()}
        </Button>
        {isCalendarOpen && (
          <Calendar value={new Date(date)} onChange={onDateSelect} />
        )}
      </div>
    )
  },
)

CalendarToggle.displayName = 'CalendarToggle'

export default CalendarToggle
